<div class="modal" [class.active]="isActive" [class.form] = "isForm" [ngClass]="type">
    <a href="#" class="close" (click)="onReject()"><span class="icon-cross"></span></a>
    <div class="modal-header" *ngIf="!disableHeader">
        <ng-content select="div[role=header]"></ng-content>
    </div>
    <div class="modal-body" [style.overflow-y]="allowDropDownOverflow ? 'inherit' : 'auto'" [style.max-height]="dynamicHeight">
        <ng-content select="div[role=body]"></ng-content>
    </div>
    <div class="modal-footer" *ngIf="!disableFooter">
        <ng-content select="div[role=footer]"></ng-content>
        <input class="{{acceptCssClass}}" name="accept" type="submit" [disabled]="disableAccept" value="{{acceptText}}" (click)="onAccept()" *ngIf="acceptText?.length > 0">
        <input class="{{rejectCssClass}}" name="reject" type="submit" value="{{rejectText}}" (click)="onReject()" *ngIf="rejectText?.length > 0">
    </div>
</div>
<div class="modal-overlay" [class.active]="isActive"></div>